// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__39iux","right":"Footer_right__EVWxY","buttons":"Footer_buttons__J0g8R"};